import { get as localDbGet } from 'idb-keyval'

export async function getUserAndEnvFromLocalStorage() {
  const { env } = JSON.parse(await localDbGet("get-tenant-data"))
  const { email } = JSON.parse(await localDbGet("get-user-data"))

  return ({
    env,
    user: email
  })
}
